// @flow

import { DraftLiveStateEnum } from "@modules/service/constants";
import type { AlertsState } from "./types";

export const initialState: AlertsState = {
  requestsInProgress: 0,
  schema: null,
  list: null,
  error: null,
  current: null,
  draft: null,
  assignments: [],
  draftAssignments: [],
  configuration: {
    enabled: true,
    status: DraftLiveStateEnum.LIVE,
  },
  modals: {
    modalStep: 1,
    showAddModal: false,
    showEditModal: false,
    showEditAssignmentsModal: false,
    showAddAlertRecipientModal: false,
    showDeleteAlertRecipientModal: false,
    showAddAlertAttachmentModal: false,
    showDeleteAlertAttachmentModal: false,
    showDiscardModal: false,
    showSubmitModal: false,
    showCancelModal: false,
    showCancelDiscardModal: false,
    showDisableModal: false,
  },
};

export default initialState;
